'use client';

import React from 'react';
import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

/**
 * 404. The generated version styled its text with `text-onBackground`, a token
 * that exists in no Tailwind config here -- so the copy rendered at the
 * browser default colour on a near-black page. Uses the real tokens instead.
 */
export default function NotFound() {
  return (
    <div
      className="min-h-screen flex items-center justify-center px-6"
      style={{ background: 'var(--background)' }}
    >
      <div className="text-center max-w-md">
        <div className="text-8xl font-bold text-primary/25 font-tabular mb-2">404</div>
        <h1 className="text-2xl font-semibold mb-2">Page not found</h1>
        <p className="text-sm text-muted-foreground mb-8 leading-relaxed">
          That page doesn&apos;t exist. It may have moved, or the link may be out of date.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            onClick={() => window.history.back()}
            className="btn-secondary px-5 py-2.5 inline-flex items-center justify-center gap-2"
          >
            <Icon name="ArrowLeftIcon" size={15} />
            Go back
          </button>
          <Link
            href="/"
            className="btn-primary px-5 py-2.5 inline-flex items-center justify-center gap-2"
          >
            <Icon name="HomeIcon" size={15} />
            Home
          </Link>
        </div>
      </div>
    </div>
  );
}
